export const lists = {
  providers: {
    title: "Поставщики",
    submitButtonText: "Добавить поставщика",
    columnNames: [
      "Название",
      "Контактное лицо",
      "Телефон",
      "Город",
      "Создан",
      "Обновлен",
    ],
    rowNames: [
      "name",
      "contact_person",
      "phone",
      "city",
      "created_at",
      "updated_at",
    ],
    filterFields: [
      {
        name: "city",
        title: "Город",
        value: "",
      },
      {
        name: "contact_person",
        title: "Контактное лицо",
        value: "",
      },
      {
        name: "phone",
        title: "Телефон",
        value: "",
      },
    ],
  },
  clients: {
    title: 'Клиенты',
    submitButtonText: 'Добавить клиента',
    columnNames: [
      'Название',
      'Город',
      'Создан',
      'Обновлен',
    ],
    rowNames: [
      'name',
      'city',
      'created_at',
      'updated_at',
    ],
    orderFields: {
      'Название': 'name',
    },
    filterFields: [
      {
        name: 'city',
        title: 'Город',
        value: '',
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/business/constants/tables.js